<div class="app-modal-title">
  <div class="title">Transaction Logs</div>
  <div class="glyphicons glyphicons-remove" (click)="cancel()"></div>
</div>
<div class="app-modal-content">
  <div class="message-list">
    <div *ngFor="let message of process.messages;" class="msg-item" [ngClass]="{'err-msg': message.type==='err'}">
      <div class="msg-timestamp">{{message.time}} &nbsp;&nbsp;</div>
      <div class="msg-content">{{message.message}}</div>
    </div>
  </div>
</div>
<!-- <ng-container *ngFor="let msg of socketMsg; let idx = index;">
  <div class="msg-item" *ngIf="msg?.dataType==='print'||msg?.isError">
    <div class="msg-timestamp">{{msg.timeStamp}} &nbsp;&nbsp;</div>
    <div class="msg-content">
        {{msg.isError ? msg.data.errorMessage + ' ' + msg.data.errorDetail : msg.data}}
    </div>
  </div>
  <ng-container *ngIf="msg?.dataType==='printJson'&&msg?.data">
    <div *ngFor="let msgDataByCate of msg.data | keyvalue">
      <div *ngFor="let msgData of msgDataByCate.value" class="msg-item" [ngClass]="{'err-msg': msgData.typ==='err'}">
        <div class="msg-timestamp">{{msgData.time}} &nbsp;&nbsp;</div>
        <div class="msg-content">
            {{msgData.print}}
        </div>
      </div>
    </div>
  </ng-container>
</ng-container> -->